import  {useEffect, useState} from 'react'
import {DspData} from './AdminDashboardByDsp';
import ReactEcharts from 'echarts-for-react';

interface Props {
    data: DspData[],
    style: {}
}

const WinBidPriceChartByDsp = (props: Props) => {

    const [option, setOption] = useState<any>()

    useEffect(() => {
        loadOptions()
    }, [props.data])

    const loadOptions = () => {

        let dspName: any[] = []
        let avgWinPriceData: any[] = []
        let avgBidPriceData: any[] = []

        props.data.forEach(d => {
            dspName.push({value: d.name})
            avgWinPriceData.push({value: d.avgWinPrice})
            avgBidPriceData.push({value: d.avgBidPrice})
        });

        const chartOption = {
            title: {
                text: 'Win Bid prices',
                subtext: 'by Dsp',
                // textStyle: {fontSize: 'auto'},
                left: 'left'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                type: 'scroll',
                top: '6%',
                left: 'center'
            },
            grid: {
                top: '12%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    axisLabel: {
                        interval: 0,
                        // rotate: 45
                    },
                    data: dspName
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    nameTextStyle: {
                        padding: [0, -40, 0, 0],
                        align: 'right',
                    }
                }
            ],
            series: [
                {
                    name: 'AvgWinPrice',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: avgWinPriceData
                },
                {
                    name: 'AvgBidPrice',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: avgBidPriceData
                }
            ]
        }
        setOption(chartOption)

    }

    return  <div>
                {option && <ReactEcharts style={props.style} option={option}/>}
            </div>
}

export default WinBidPriceChartByDsp
